var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"car",staticStyle:{"margin-top":"99px"}},[_c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":_vm.heigh}},_vm._l((_vm.banner),function(item){return _c('el-carousel-item',{key:item},[_c('img',{ref:"img_ref",refInFor:true,staticClass:"carimg",attrs:{"id":"oImg","src":item},on:{"load":_vm.img_load}})])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }